export default "__VITE_ASSET__BRz1JiCS__"